import React from 'react'
import { auth } from '../firebase-config'
import { signOut } from 'firebase/auth'
import { Navigate } from 'react-router-dom'
import './Button.module.css'

export async function logOut({ user }) {
  await signOut(auth)
  
  if (!user) return <Navigate to='/'></Navigate>
}

export const Button = ({ type = 'button', onClick, children }) => {

  return (
    <button type={type} onClick={onClick}>
      {children}
    </button>
  )
}
